module.exports = true;



//////////////////
// WEBPACK FOOTER
// D:/xampp_bk/htdocs/xampp/organicshop/~/core-js/library/modules/_library.js
// module id = ../../../../core-js/library/modules/_library.js
// module chunks = 3